'use strict';
import Promise from 'bluebird';
import $ from 'jquery';
const API_URL = '/fi/api/v1/shops/';

export const getShops = () => Promise.resolve($.get(API_URL));
